import { useTranslation } from "react-i18next";
import { MediaQuery } from "@outplayed/responsive";
import EditableFullRuneTree from "@ugg/shared/components/common/RuneTrees/EditableFullRuneTree";
import { getPercetange, numberWithCommas } from "@ugg/shared/utils/math";
import { getRoleLabel, RoleS } from "@ugg/shared/utils/role-helpers";
import { capitalizeMulti } from "@ugg/shared/utils/multi-build-helpers";
import { OverviewInfo } from "@ugg/shared/api/data-parser/champions/overview";

interface RunesProps {
  championName: string;
  role: string;
  patch: string;
  recRunes: OverviewInfo["rec_runes"];
  statShards?: OverviewInfo["stat_shards"];
  multi?: string;
}

export default function Runes(props: RunesProps) {
  const { t } = useTranslation();
  const { statShards, recRunes, patch, championName, role, multi } = props;

  return (
    <div className="content-section_content recommended-build_runes">
      <div className="content-section_header">
        <div className="main-header">
          <span style={{ marginRight: 12 }}>
            {multi && capitalizeMulti(multi, "")
              ? `${capitalizeMulti(multi)} ${championName} ${t("Runes")}`
              : `${championName} ${t("Runes")}`}
          </span>
          <MediaQuery min="TABLET" max="DESKTOP_LARGE">
            <span className="content-section_blurb truncate" style={{ direction: "rtl" }}>
              {multi && capitalizeMulti(multi, "")
                ? `${capitalizeMulti(multi)} ${championName} ${getRoleLabel(role, (label) =>
                    label === "Bottom" ? "ADC" : label,
                  )} Build`
                : `${championName} ${getRoleLabel(role, (label) => (label === "Bottom" ? "ADC" : label))} Build`}
            </span>
          </MediaQuery>
        </div>
        <div className="wr-matches">
          {recRunes && (
            <>
              <span className={"win-rate"}>{`${getPercetange(recRunes.wins, recRunes.matches, 2)}% WR `}</span>
              <MediaQuery min="TABLET" max="DESKTOP_LARGE">
                <span className="matches">{`(${numberWithCommas(recRunes.matches)} Matches)`}</span>
              </MediaQuery>
            </>
          )}
        </div>
      </div>
      {recRunes && statShards && (
        <div>
          <MediaQuery min="MOBILE_LARGE" max="DESKTOP_LARGE">
            <EditableFullRuneTree recRunes={recRunes} statShards={statShards} patch={patch} ssr />
          </MediaQuery>
          <MediaQuery min="MOBILE_SMALL" max="MOBILE_MEDIUM">
            <EditableFullRuneTree recRunes={recRunes} statShards={statShards} patch={patch} ssr isMobile />
          </MediaQuery>
        </div>
      )}
    </div>
  );
}
